import React from 'react';
import PropTypes from 'prop-types';
import BusinessAppStateProvider from '../../context/business-app-state.context';
import GlobalStyles from '../../styles/globalStyles';
import BusinessLayout from './layouts/BusinessLayout';
import '../../styles/fonts/brown.css';

const BusinessPage = ({ blok }) => (
  <BusinessAppStateProvider blok={blok}>
    <GlobalStyles dark />
    <BusinessLayout blok={blok} />
  </BusinessAppStateProvider>
);

BusinessPage.propTypes = {
  blok: PropTypes.any.isRequired,
};

export default BusinessPage;
